export class SurveyOverview {
  id: number;
  title: string;
  text: string;
}

export class SurveyConfig {
  id: number;
  title: string;
  text: string;
  footerText: string;
  questions: any[];
  settings: any[];
  classes: any[];
  other: string;
}

export class ResultSurvey {
  id: number;
  title: string;
  message: string;
  surveyQuestions: ResultQuestion[];
}

export class ResultQuestion {
  id: number;
  questionText: string;
  answers: ResultAnswer[];
}

export class ResultAnswer {
  id: number;
  answerText: string;
  selectionCount: number;
}



// WEBPACK FOOTER //
// ./src/app/surveys/shared/survey.model.ts